<template lang="pug">
transition(
name="slide"
)
  .button-menu(@click="openMenu" :class="{'untouchable': disable}")
    icon-menu

</template>

<script>

  import IconMenu from 'src/components/vca/widgets/IconMenu'
  import {mapMutations} from 'vuex'
  export default {
    name: 'button-menu',
    components: {
      IconMenu,
    },
    data() {
      return {}
    },
    props: {
      disable:{
        default: false
      }
    },
    computed: {},
    mounted() {
      window.ButtonMenu = this
    },
    beforeDestroy() {},
    methods: {
      ...mapMutations('app', ['openMenu']),
      hide(){
        let tl = new TimelineMax({})
        this.tl = tl
        //console.log('tltlttlt')
        tl.add('start')
          .to(
            this.$el,
            0.7,
            {
              opacity: 0,
              x: -100,
              ease: Power2.easeOut
            },
            `start+=0`
          )


      },
      show(){
        let tl = new TimelineMax({})
        this.tl = tl
        //console.log('tltlttlt')
        tl.add('start')
          .to(
            this.$el,
            0.7,
            {
              opacity: 1,
              x: 0,
              ease: Power2.easeOut
            },
            `start+=0`
          )


      }
    },
    watch: {},
  }
</script>

<style lang="sass" scoped>
  @import "src/styles/common.sass"

  .button-menu
    //background: #e15125
    //opacity: 0.5
    pointer-events: all
    position: absolute
    top: $ui-margin-top - 0.55rem
    left: $ui-margin-left - 0.1rem
    width: 0.5rem
    padding: 0.13rem
    &.untouchable
      pointer-events: none
  .slide-enter-active, .slide-leave-active
    transition: all 0.7s ease-out 1s

  .slide-enter, .slide-leave-to
    transform: translateX(-100%)
    opacity: 0


  // img
  //   display: block
  //   +center-img()
  //   max-width: 70%
  //   max-height: 70%

</style>
